var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkeyFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag Pack",
    clipPath: "url(#clip0_8987_19377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9546 12.11H-1.06828C-1.23212 12.11 -1.36498 11.9772 -1.36498 11.8133V0.227127C-1.36498 0.0632873 -1.23212 -0.0695683 -1.06828 -0.0695683H16.9547C17.1185 -0.0695683 17.2514 0.0632873 17.2514 0.227127V11.8133C17.2513 11.9772 17.1185 12.11 16.9546 12.11Z",
    fill: "#FF4B55",
    stroke: "#3A3D5A",
    strokeWidth: 0.0503165
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.44821 6.02058C3.44821 7.44354 4.60145 8.59683 6.02314 8.59683C6.55299 8.59683 7.04157 8.43401 7.44852 8.15805C7.51017 8.11627 7.58137 8.19685 7.52978 8.25055C6.94594 8.85867 6.12833 9.23901 5.21858 9.23901C3.37175 9.23901 1.88841 7.68213 2.00825 5.80879C2.11292 4.17328 3.46888 2.86005 5.1068 2.80416C6.06019 2.7716 6.92002 3.15693 7.52756 3.78857C7.57966 3.84275 7.5086 3.92452 7.44636 3.88238C7.03985 3.60704 6.55208 3.44437 6.02314 3.44437C4.60149 3.44437 3.44821 4.60024 3.44821 6.02058Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3173 5.5778L8.81283 4.91787C8.78465 4.88098 8.72566 4.90121 8.7261 4.94766L8.73346 5.77829L7.94994 6.05413C7.90611 6.06955 7.90717 6.13186 7.95147 6.14582L8.74371 6.39553L8.76394 7.22594C8.76507 7.27235 8.82472 7.29061 8.85166 7.2528L9.33393 6.5765L10.13 6.81388C10.1744 6.82715 10.2102 6.77615 10.1826 6.73882L9.68841 6.07112L10.1601 5.38742C10.1865 5.34921 10.1491 5.29941 10.105 5.31414L9.3173 5.5778Z",
    fill: "#F5F5F5"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8987_19377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkeyFlag);
export default __webpack_public_path__ + "static/media/Turkey_flag.79a525d7dbc7c223aec93d8e17dd6a9d.svg";
export { ForwardRef as ReactComponent };